/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import {
  SubmitHangingConfirmationFollowUpInterface,
  SubmitHangingConfirmationUpdateStatusInterface
} from "../contracts/HangingRequest";
import { getHubData } from "@/app/infrastructures/misc/Cookies";

export class SubmitHangingConfirmationFollowUp
  implements SubmitHangingConfirmationFollowUpInterface {
  activityType = "";
  courierName = "";
  courierPhone = "";
  checkerUsername = "";
  origin3lc = "";
  originName = "";
  constructor(fields?: Partial<SubmitHangingConfirmationFollowUp>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify({
      activity_type: this.activityType,
      courier_name: this.courierName,
      courier_phone: this.courierPhone,
      checker_username: this.checkerUsername,
      origin_3lc: this.origin3lc,
      origin_name: this.originName,
      hub_id: getHubData()?.hubId || 0
    });
  }
}

export class SubmitHangingConfirmationUpdateStatus
  implements SubmitHangingConfirmationUpdateStatusInterface {
  customProcessStatus = "";
  sttNo = [] as Array<string>;
  remarks = "";
  partnerId = 0;
  pageType = "";
  constructor(fields?: Partial<SubmitHangingConfirmationUpdateStatus>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify({
      custom_process_status: this.customProcessStatus,
      stt_no: this.sttNo,
      remarks: this.remarks,
      partner_id: this.partnerId,
      page_type: this.pageType,
      hub_id: getHubData()?.hubId || 0
    });
  }
}

export class HangingLastMileConfirmApiRequest
  implements SubmitHangingConfirmationFollowUpInterface {
  activityType = "";
  courierName = "";
  courierPhone = "";

  constructor(fields?: Partial<HangingLastMileConfirmApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
        hubId: getHubData()?.hubId || 0
      })
    );
  }
}

export class HangingConfirmDonePosBkdPayload {
  hubId = 0;
  activityType = "";
  followUpPartnerCode = "";
  followUpPartnerType = "";
  followUpPartnerName = "";
  username = "";
  constructor(fields?: Partial<HangingConfirmDonePosBkdPayload>) {
    Object.assign(this, fields);

    if (getHubData()?.hubId) {
      this.hubId = getHubData()?.hubId;
    }
  }

  public toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}
